import React, {
  useState,
  useEffect,
} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTimes, FaChevronRight } from 'react-icons/fa';
import Map from './Map';
import TicketChecked from './TicketChecked';
import TimeLibrary from '../../libraries/Time';
import EditIcon from '../../assets/images/eticket/edit.png';
import DeviceStoreButtons from "./DeviceStoreButtons";
import TicketDetailsModal from './TicketDetailsModal';
import FrauenImage from "../../assets/images/eticket/frauen_eticket.jpg";
import FrauenLogo from "../../assets/images/eticket/SCB-FRAUEN_logo.png";
import useModal from '../../hooks/useModal';
import UserLibrary from '../../libraries/User';

/**
 * Modal component
 * @param {Object} [props]
 * @param {Object} [props.guest] - Guest data
 * @param {Function} [props.guestForm] - Callback method for guest from
 * @param {boolean} [props.ticketChecked] - Is ticket checked
 * @component
 */
export default ({ guest = {}, guestForm = () => {}, ticketChecked = false, isTicketClosable = false }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const source = query.get('openedBy'); 
  const isAuth = UserLibrary.isLoggedIn();
  const [showMap, setShowMap] = useState(false);
  const [isModalOpen, setIsModalOpen] = useModal(false);
  
  useEffect(() => void(document.querySelector('html').style.overflow = showMap ? 'hidden' : 'auto'), [showMap]);
  useEffect(() => {
    const storedHashes = JSON.parse(localStorage.getItem("guestHashes")) || [];
    const showModal = !storedHashes.includes(guest.access_token) && !isAuth;
    if ( guest.access_token && showModal && source !== "admin")
      {
        setIsModalOpen(true);
      }
      else
      {
        setIsModalOpen(false);
      }
  }, [guest.access_token, source, isAuth]);


  return (
    <div className="ticket-view">
    {isModalOpen && <TicketDetailsModal onClose={() => setIsModalOpen(false) }
          league_acronym={guest?.game?.league_acronym} guestHash={guest.access_token}
          access_id={guest.id}
        />}
      
      {isTicketClosable &&
        <Link className='close-button' to='/tickets'>
          <FaTimes />
        </Link>
      }

      {guest?.game?.is_women_league ? (
        <div className="women-league-container">
          <img src={FrauenImage} alt="Women's League" className="background-image" />
          <div className="gradient-overlay"></div>
          <img src={FrauenLogo} alt="SCB Frauen Logo" className="overlay-logo" />
        </div>
      ) : 
      
      ticketChecked ? (
        <TicketChecked guest={guest} />
      ) : (
        <div className="no-info">
          <p>Es fehlen Angaben zum Besucher!</p>

          {!!guest.game.date && guest.gameHasEnded && <p>Dieses Spiel ist schon zu Ende</p>}

          {!guest.game.date && <p>Spiel wurde verschoben - Neuer Termin ausstehend</p>}

          {!!guest.game.date && (
            <button onClick={guestForm} disabled={guest.gameHasEnded} style={{ opacity: guest.gameHasEnded ? 0.5 : 1 }}>
              <img src={EditIcon} alt="edit icon"/>

              <span>DATEN ANPASSEN</span>
            </button>
          )}
        </div>
      )}

      <h3 className="no-print" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <DeviceStoreButtons />
      </h3>
      
      <div className="ticket-details">
        {guest?.pass_type && guest?.game?.is_women_league === false && (
          <div className="transport-info">
            <h3>{guest.pass_type}</h3>
          </div>
        )}

        <div className="seat-details">
        {guest?.game?.is_women_league ? (
          <h3>FREIE PLATZWAHL</h3>
        ) : (
          !!guest?.seat?.seat_group?.sector && (
            <>
              <h3>Eingang {guest.seat.seat_group.sector.title}</h3>

              <p>Block {guest.seat.seat_group.title}</p>

              {guest.seat.row && <p>Reihe {guest.seat.row}</p>}

              {guest.seat.num && <p>Sitz {guest.seat.num}</p>}

              {/* <div className="map-btn-row">
                <button onClick={() => setShowMap(true)}>
                  <img src={MapIcon} alt="map icon" />

                  <FaAngleRight/>
                </button>
              </div> */}
            </>
          )
        )}
        </div>

        <div className="game-details">
          {!!guest?.game?.away_team && (
            <>
              <h3>{guest.game.home_team.title} - {guest.game.away_team.title}</h3>

              <p>
                {!!guest.game.date ? (
                  <>
                    <span>{TimeLibrary.date(guest.game.date)}, </span>

                    <span>{TimeLibrary.time(guest.game.date)}</span>
                  </>
                ) : <span><em>Nachholtermin noch unbekannt</em></span>}
              </p>

              <p>PostFinance Arena</p>

              <p>Türöffnung: {guest?.game?.is_women_league ? "1h" : "1h45"} vor dem Spiel</p>
            </>
          )}
        </div>

        {/* Forwarding a ticket and buying more are screen-only actions — on
            paper they only pushed the ticket onto a second page. */}
        <div className="transfer-alert no-print">
          <h3>
            Ticket-Weitergabe
          </h3>

          <p>
            Bitte beachte, dass auch weitergegebene Tickets nur für eine Person gültig sind.

            <br /><br />

            Um weitere Personen für den Matchbesuch zu berechtigen, können Einzeltickets gekauft werden.
          </p>

          <a href="https://www.ticket-onlineshop.com/ols/scb/de/meisterschaft/channel/shop/index" rel="transfer ticket">
            Zu den einzeltickets

            <FaChevronRight />
          </a>
        </div>
        {!guest?.game?.is_women_league && (
          <div className="transport-info">
            <h3>QR-Code auch für BernMobil</h3>
            <p>
              Hin- und Rückfahrt in den Libero-Zonen 100 & 101 zur PostFinance-Arena
              sind ab drei Stunden vor Matchbeginn und bis zu zwei Stunden nach
              Spielschluss (neu inkl. Nachtbusse) im Matchticket inbegriffen.
            </p>
          </div>
        )}


      </div>

      {showMap && <Map close={() => setShowMap(false)}/>}
    </div>
  )
};
